import _ from 'lodash';
import { ADS_ADMIN_PREFIX } from './constants';

const modifyDeleteErrorMessage = (catchErrors: object|undefined): string => {
  let modifiedDeleteErrorMessage: string = '';

  if (catchErrors !== undefined && _.isPlainObject(catchErrors)) {
    // Create an array of just the error message strings.
    const deleteErrorMessageArray: string[] = [];
    Object.values(catchErrors)
      .forEach((catchError: any) => {
        if (Array.isArray(catchError.Errors)) {
          deleteErrorMessageArray.push(...catchError.Errors);
        }
      });

    // Override error messages (ex: to insert html).
    const newDeleteErrorMessageArray: string[] = deleteErrorMessageArray
      .map((deleteErrorMessage: string) => {
        let newDeleteErrorMessage: string = deleteErrorMessage;
        if (newDeleteErrorMessage === 'You cannot delete a contact if it\'s still attached to any litters.') {
          newDeleteErrorMessage += ` You must delete any remaining litters or <a href="${ADS_ADMIN_PREFIX}">move them to another seller contact</a>.`;
        }
        return newDeleteErrorMessage;
      });

    // Prepare string for display.
    modifiedDeleteErrorMessage = newDeleteErrorMessageArray.join(' ');
  }

  return modifiedDeleteErrorMessage;
};

export default modifyDeleteErrorMessage;
